import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/legal/PrivacyPolicy";
import PrivacyPolicy20261001 from "../pages/legal/PrivacyPolicy20261001";
import PrivacyPolicy20261005 from "../pages/legal/PrivacyPolicy20261005";
import AccountDeletion from "../pages/legal/AccountDeletion";
import LocationServiceTerms from "../pages/legal/LocationServiceTerms";
import ServiceTerms from "../pages/legal/ServiceTerms";
import NoticeList from "../pages/notices/NoticeList";
import NoticeDetail from "../pages/notices/NoticeDetail";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/privacy/2026-10-05",
    element: <PrivacyPolicy20261005 />,
  },
  {
    path: "/privacy/2026-10-01",
    element: <PrivacyPolicy20261001 />,
  },
  {
    path: "/account-deletion",
    element: <AccountDeletion />,
  },
  {
    path: "/location-terms",
    element: <LocationServiceTerms />,
  },
  {
    path: "/terms",
    element: <ServiceTerms />,
  },
  {
    path: "/notices",
    element: <NoticeList />,
  },
  {
    path: "/notices/:id",
    element: <NoticeDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
